import { PressEventsType } from '@osmosis/backend/orm-db';

/**
 * Get the title from the url.
 */
export const urlToTitle = (url: string) =>
  decodeURIComponent(url.toLowerCase().replace(/-/g, ' '));

/**
 * Get url from the title.
 */
export const titleToUrl = (title: string) =>
  title.toLowerCase().replace(/ /g, '-');

/**
 * Partitions events between upcoming and past.
 */
export const partitionEvents = (events: PressEventsType[]) => {
  const adjustUTC = (date: Date) => {
    date.setUTCHours(0, 0, 0, 0);
    date.setUTCHours(date.getUTCHours() - 4);
    return date;
  };

  // Sort by date
  const sortedEvents = [...events].sort(
    (a, b) =>
      adjustUTC(new Date(a.Date || '')).getTime() -
      adjustUTC(new Date(b.Date || '')).getTime(),
  );

  const today = adjustUTC(new Date());

  // Partition by upcoming and past items
  const upcomingEvents = sortedEvents.filter(
    (event) => adjustUTC(new Date(event.Date || '')) >= today,
  );
  const pastEvents = sortedEvents
    .filter((event) => adjustUTC(new Date(event.Date || '')) < today)
    .reverse();

  return { upcomingEvents, pastEvents };
};
